import React from 'react';
import StyledButton from '@src/components/wysiwyg_editor/page_content_items/control_panels/StyledButton';
import deleteImg from '@images/wysiwyg_editor/control_panels/delete.svg';
import deleteHoverImg from '@images/wysiwyg_editor/control_panels/delete-hover.svg';

type TProps = {
  onClick: () => void;
};

function Delete(props: TProps) {
  return (
    <StyledButton
      image={deleteImg as string}
      hoverImage={deleteHoverImg as string}
      onClick={props.onClick}
    >
      Delete
    </StyledButton>
  );
}

export default Delete;
